import React from 'react';
import './dashboardlist.scss';
import logo from '../../../assets/OHM_1.png';
import { MdDashboard } from 'react-icons/md';
import procedures from '../../../assets/Icons/Procedure.png';
import { SiAwsorganizations } from 'react-icons/si';
import { RiUserSettingsLine } from 'react-icons/ri';
import { GoQuestion } from 'react-icons/go';
import { Link } from 'react-router-dom';
const DashboardListIcons = () => {
  return (
    <>
      <div className="main m-2 w-[6vw] flex flex-wrap place-content-start place-items-center  bg-white rounded-xl">
        <div className="logo-top rounded-t-xl">
          <div className="logo m-2 py-4  ">
            <img src={logo} alt="" />
          </div>
        </div>
        <Link to="/dashboard">
          <div className="dashboard  bg-white text-3xl my-3">
            <div className="poz">
              <div className="dashboard-icon flex  place-content-center">
                <MdDashboard />
              </div>
              <div className="heading-dasgboard flex place-content-center aline-item-center mx-2 text-xs   ">
                <p>Dashboard</p>
              </div>
            </div>
          </div>
        </Link>
        <Link to="/procedures">
          <div className="dashboard bg-white  text-3xl my-3">
            <div className="poz">
              <div className="dashboard-icon  place-content-center mx-4">
                <img src={procedures} alt="procedures" />
              </div>
              <div className="heading-dasgboard text-xs mx-2  ">
                <p>Procedures</p>
              </div>
            </div>
          </div>
        </Link>
        <Link to="/organization">
          <div className="dashboard bg-white   text-3xl my-3 ">
            <div className="poz">
              <div className="dashboard-icon  place-content-center mx-6">
                <SiAwsorganizations />
              </div>
              <div className="heading-dasgboard text-xs mx-2  ">
                <p>Organization</p>
              </div>
            </div>
          </div>
        </Link>
        <Link to="/user">
          <div className="dashboard  bg-white text-3xl my-3 ">
            <div className="poz">
              <div className="dashboard-icon  place-content-center mx-6">
                <RiUserSettingsLine />
              </div>
              <div className="heading-dasgboard text-xs mx-2  ">
                <p>User Roles</p>
              </div>
            </div>
          </div>
        </Link>
        <Link to="/help">
          <div className="help text-3xl ml-6">
            <div className="pos">
              <div className="icon-help ">
                <GoQuestion />
              </div>
              <div className="text text-xs ml-1">help</div>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default DashboardListIcons;
